"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var LocalizationProvider_1 = require("./components/LocalizationProvider/LocalizationProvider");
exports.LocalizationProvider = LocalizationProvider_1.default;
var LocalizationConfig_1 = require("./components/LocalizationConfig/LocalizationConfig");
exports.LocalizationConfig = LocalizationConfig_1.default;
var TranslationConsumer_1 = require("./components/TranslationConsumer/TranslationConsumer");
exports.TranslationConsumer = TranslationConsumer_1.default;
var Translation_1 = require("./components/Translation/Translation");
exports.Translation = Translation_1.default;
var LocalNumber_1 = require("./components/LocalNumber/LocalNumber");
exports.LocalNumber = LocalNumber_1.default;
var LocalUnit_1 = require("./components/LocalUnit/LocalUnit");
exports.LocalUnit = LocalUnit_1.default;
var LocalDate_1 = require("./components/LocalDate/LocalDate");
exports.LocalDate = LocalDate_1.default;
var InjectLocalization_1 = require("./components/InjectLocalization/InjectLocalization");
exports.InjectLocalization = InjectLocalization_1.default;
var useTranslation_1 = require("./hooks/useTranslation/useTranslation");
exports.useTranslation = useTranslation_1.default;
var configureLocalization_1 = require("./config/ConfigureLocalization/configureLocalization");
exports.configureLocalization = configureLocalization_1.default;
var useLocalNumber_1 = require("./hooks/useLocalNumber/useLocalNumber");
exports.useLocalNumber = useLocalNumber_1.useLocalNumber;
var useLocalUnit_1 = require("./hooks/useLocalUnit/useLocalUnit");
exports.useLocalUnit = useLocalUnit_1.useLocalUnit;
var useLocalDate_1 = require("./hooks/useLocalDate/useLocalDate");
exports.useLocalDate = useLocalDate_1.useLocalDate;
__export(require("./utils/globalizeTranslations"));
